import React from 'react'
import Heading from './Heading';
import UserList from './UserList';

const Home = () => {

    return (
        <div>
            <Heading />
            <UserList />
        </div>
    )
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js